module.exports = __webpack_public_path__ + "static/TT1394_TW-MARK-M02_r1-clean-6b4a1e25c7cfb86f408364658052dca5.png";